import {
    EnvironmentProviders,
    Provider,
} from '@angular/core';
import { AuthStateService } from './services/auth-state.service';
import { AuthService } from './services/auth.service';
import { RefreshTokenService } from './services/refresh-token.service';
import { TokenService } from './services/token.service';
import { UserSyncService } from './services/user-sync.service';
import { UserSetupService } from './services/user-setup.service';
import { UserStorageService } from './services/user-storage.service';
import { PermissionsSetupService } from './services/permissions-setup.service';
import { AuthOrchestratorService } from './services/auth-orchestrator.service';
import { AuthCleanupService } from './services/auth-cleanup.service';
import { PostLoginSetupService } from './services/post-login-setup.service';
import { LocalStorageService } from './services/local-storage.service';
import { smartAuthInterceptor } from './interceptors/smart-auth.interceptor';
import { AuthConfigService } from './services/auth-config.service';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [       
        // Core auth services
        AuthConfigService,
        LocalStorageService,
        TokenService,
        AuthStateService,
        UserSyncService,
        RefreshTokenService,
        AuthService,
        
        // Business logic services
        UserSetupService,
        UserStorageService,
        PermissionsSetupService,
        PostLoginSetupService,
        
        // Utility services
        AuthCleanupService,
        
        // Orchestrator service
        AuthOrchestratorService,
    ];
};
